<h5 class="mb-5">Welcome to your portal management page!</h5>

<div class="text-muted">
    <h5 class="mb-3">Registration Information</h5>

    <p class="mb-4">There are two ways to register or on-board all of your users. One or both methods may be used depending upon your district circumstances and/or needs. Note - Current PA-ETEP
        clients should first migrate any PA-ETEP user accounts into Comply, and then add any new user accounts.  For detailed instructions on how to on-board or migrate users, click
        the Support link in the header, and access the article called User Registration.</p>

    <h5 class="mb-3">User Roles and Permissions</h5>

    <p class="mb-4">Comply has three different user roles or permission levels (Basic User, Supervisor User, and Admin User/Portal Manager). Each user may only have one role in the Comply software.
        For a detailed description of each of these roles, click the Support link in the header, and access the article called User Roles and Permissions.</p>

    <h5 class="mb-3">PA-ETEP and Comply Users</h5>

    <p class="mb-4">If your district or organization uses both PA-ETEP and Comply, your users/employees will use the same username and password for both software platforms.  Please note that if a
        username or password is changed in Comply, it will also be changed in PA-ETEP (and vice versa).</p>

    <h5 class="mb-3">Questions / Support</h5>

    <p>Whenever you need help or have questions, click the Support link in the header, and view the various support articles or submit a New Support Ticket.</p>
</div>